import { apiClient } from './apiClient';

export type MonthlyGoal = {
  id?: number;
  year: number;
  month: number;
  goal_amount: string;
  received_amount: string;
  percentage: number;
};

export async function getMonthlyGoal(token: string, year: number, month: number) {
  return apiClient<{ data: MonthlyGoal }>(`/monthly-goals/${year}/${month}`, {
    method: 'GET',
    token,
  });
}

export async function updateMonthlyGoal(
  token: string,
  year: number,
  month: number,
  goalAmount: number,
) {
  return apiClient<{ data: MonthlyGoal }>(`/monthly-goals/${year}/${month}`, {
    method: 'PUT',
    token,
    body: JSON.stringify({ goal_amount: goalAmount }),
  });
}

